import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { SidebarProvider } from "./constants/stateManagement/SidebarProvider";
import { GetUserDataProvider } from "./constants/stateManagement/GetUserDataProvider";
import "bootstrap/dist/css/bootstrap.min.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
   // <React.StrictMode>
   <BrowserRouter>
      <SidebarProvider>
         <GetUserDataProvider>
            <App />
         </GetUserDataProvider>
      </SidebarProvider>
   </BrowserRouter>
   // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
